import SMSReader from '@apps/phone/admin/components/sms_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  component: <SMSReader phone_number={ props.number } />
})

export default Panel(null, mapPropsToPanel)
